import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';

import { Icon, Typography } from '@sravni/react-design-system';

import { IMenuFormat } from '../../../../hooks/formats';
import { scrollToTop } from '../../../../utils/srollTo';

import styles from './menu-item.module.scss';

interface IProps {
  item: IMenuFormat;
  onClick?: () => void;
}

export const MenuItem = ({ item, onClick }: IProps) => {
  const linkItem = (
    <Typography.Link
      color={'dark'}
      href={item.url || item.link?.as || null}
      className={classNames(styles.itemLink, { [styles[`itemLink--active`]]: item.isActive })}
    >
      <Icon shape={'round'} size={16} className={styles.itemIcon} color={'dark'}>
        {item.icon}
      </Icon>
      {item.name}
    </Typography.Link>
  );

  return (
    <Typography.Text
      size={14}
      strong
      className={classNames(styles.item)}
      key={`format-${item.name}`}
      onClick={onClick || scrollToTop}
    >
      {item.isExternal || !item.link ? (
        linkItem
      ) : (
        <Link href={item.link.href} as={item.link.as}>
          {linkItem}
        </Link>
      )}
    </Typography.Text>
  );
};
